import {
    ALL_SELECTED_LABEL_3,
    validPropMultiSelectVM,
} from '../../../../core/components/validation/ValidInputMultiSelect';
import { validOptionalPropTextVM } from '../../../../core/components/validation/ValidInputText';
import { validPropDateVM } from '../../../../core/components/validation/ValidInputDate';
import { OpsFeedsSearchModel } from './feeds_search_types';
import { getLocalToday } from '../../../../core/components/validation/ValidInputDate.utils';

export function feedsSearchStateVM(_data: any = {}): OpsFeedsSearchModel {
    const data = _data ?? {};
    const today = getLocalToday();

    let feedTypeOpts = data.FeedType?.val;
    if (data.FeedType?.val?.length > data.feedTypeOptions?.length) {
        feedTypeOpts = data.feedTypeOptions.map(opt => opt.lbl);
    }
    let rxOpts = data.RX?.val;
    if (data.RX?.val?.length > data.pharmacyOptions?.length) {
        rxOpts = data.pharmacyOptions.map(opt => opt.lbl);
    } else if (data.RX?.val?.length === data.pharmacyOptions?.length) {
        rxOpts = [ALL_SELECTED_LABEL_3];
    }
    let ceOpts = data.CE?.val;
    if (data.CE?.val?.length > data.facilityOptions?.length) {
        ceOpts = data.facilityOptions.map(opt => opt.lbl);
    }

    return {
        /** We keep Facility and Pharmacy as CE and RX to match the API format. */
        CE: validPropMultiSelectVM(
            'CE',
            'Facilities',
            ceOpts ?? [ALL_SELECTED_LABEL_3],
            'CE',
            data.facilityOptions || [],
        ),
        RX: validPropMultiSelectVM(
            'RX',
            'Pharmacies',
            rxOpts ?? [ALL_SELECTED_LABEL_3],
            'RX',
            data.pharmacyOptions || [],
        ),
        FeedType: validPropMultiSelectVM(
            'FeedType',
            'Feed Type',
            feedTypeOpts ?? [ALL_SELECTED_LABEL_3],
            'FeedType',
            data.feedTypeOptions || [],
        ),
        Status: validPropMultiSelectVM(
            'Status',
            'Status',
            data.Status?.val ?? [ALL_SELECTED_LABEL_3],
            'Status',
            data.statusOptions || [],
        ),
        Source: validPropMultiSelectVM(
            'Source',
            'Source',
            data.Source?.val ?? [ALL_SELECTED_LABEL_3],
            'Source',
            data.sourceOptions || [],
        ),
        StartDate: validPropDateVM('StartDate', 'Start Date', data.StartDate?.val ?? today),
        EndDate: validPropDateVM('EndDate', 'End Date', data.EndDate?.val ?? today),
        DateRangeMode: validOptionalPropTextVM(
            'DateRangeMode',
            'Date Range Mode',
            data.DateRangeMode?.val,
            'TODAY',
            false,
        ),
    };
}
